<div
  *ngIf="isColumn"
  class="spacing-controller-component right"
  [style.left.px]="rightX"
  [style.top.px]="rightY"
>
  <div class="flex-row gap-4">
    <nw-icon
      *ngIf="!shapeService.evenGap"
      type="align_space_even"
      [outlined]="true"
      (click)="evenAlignColumn()"
    ></nw-icon>
    <div *ngIf="shapeService.evenGap" style="transform: rotate(90deg)">
      <nw-icon
        (mousedown)="onDragStart($event, 'vertical')"
        type="arrow_range"
        [outlined]="true"
      >
      </nw-icon>
    </div>

    <!-- 
    <ng-template #rowAlign>
      <div class="flex-column gap-6">
        <nw-icon type="align_vertical_top"></nw-icon>
        <nw-icon type="align_vertical_center"></nw-icon>
        <nw-icon type="align_vertical_bottom"></nw-icon>
      </div>
    </ng-template> 
    -->
  </div>
</div>

<div
  *ngIf="isRow"
  class="spacing-controller-component bottom"
  [style.left.px]="bottomX"
  [style.top.px]="bottomY"
>
  <div
    class="flex-column gap-4"
    (mousedown)="onDragStart($event, 'horizontal')"
  >
    <nw-icon
      type="align_justify_space_even"
      *ngIf="!shapeService.evenGap"
      [outlined]="true"
      (click)="evenAlignRow()"
    ></nw-icon>
    <div *ngIf="shapeService.evenGap" style="position: relative; left: -4px">
      <nw-icon type="arrow_range" [outlined]="true"> </nw-icon>
    </div>

    <!--  <ng-template #columnAlign>
      <div class="flex-row gap-6">
        <nw-icon type="align_horizontal_top"></nw-icon>
        <nw-icon type="align_horizontal_center"></nw-icon>
        <nw-icon type="align_horizontal_bottom"></nw-icon>
      </div> 
    </ng-template> -->
  </div>
</div>
